import GlobalTypes from "./GlobalTypes";
import { postDataAPI } from "../../utils/API";

export const ICO_TYPES = {
	LOADING: "LOADING",
	CREATE_ICO: "CREATE_ICO",
	GET_ICO: "GET_ICO",
	ID: "ID",
	GET_COMPLETED: "GET_COMPLETED",
	GET_PROFILE: "GET_PROFILE",
	DEPLOY: "DEPLOY",
	CONTRACT_DETAIL: "CONTRACT_DETAIL",
};

export const deploynewcontract = (data, auth) => async (dispatch) => {
	try {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: true } });
		const token = auth?.data?.accesstoken || auth?.data?.access_token;
		const res = await postDataAPI("deploy", data, token);

		dispatch({
			type: ICO_TYPES.DEPLOY,
			payload: {
				data: res.data,
			},
		});
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
	} catch (err) {
		dispatch({ type: GlobalTypes.NOTIFY, payload: { loading: false } });
		const msg =
			err?.response?.data?.msg ||
			err?.response?.data?.message ||
			err?.message ||
			"Deployment failed. Please try again.";
		dispatch({
			type: GlobalTypes.NOTIFY,
			payload: { error: msg },
		});
	}
};
